export function getRecaptchaToken(action) {
  return new Promise((resolve, reject) => {

    if(window.grecaptcha == null) throw new Error('reCaptcha SDK not found')

    grecaptcha.ready(function() {
      grecaptcha.execute(process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY, {action})
        .then(resolve)
        .catch(reject)
    })
  })  
}